import React, { useState } from 'react';
import { useFamilyContext } from '../../../contexts/FamilyContext';
import JobsBoard from '../JobsBoard';

export default function FamilyJobsSection() {
  const { family } = useFamilyContext();
  const [_showCreateJob, setShowCreateJob] = useState(false);

  const handleAddJob = () => {
    // TODO: Implement job creation modal
    console.log('Add job clicked');
    setShowCreateJob(true);
  };

  const handleCreateFirstJob = () => {
    // TODO: Implement first job creation
    console.log('Create first job clicked');
    setShowCreateJob(true);
  };

  // Check if there are any existing jobs
  const hasJobs = family?.jobs && family.jobs.length > 0;

  return (
    <div className="allowance-card jobs-section">
      <div className="allowance-card-header">
        <h2 className="allowance-card-title">
          <span className="allowance-card-icon">💼</span>
          Family Jobs
        </h2>
        {hasJobs && (
          <button 
            className="add-job-btn"
            onClick={handleAddJob}
            aria-label="Add new job"
          >
            + Add Job
          </button>
        )}
      </div>
      
      {hasJobs ? (
        <JobsBoard isParent={true} />
      ) : (
        <div className="empty-state">
          <div className="empty-icon">🎯</div>
          <h3 className="empty-title">No jobs created yet</h3>
          <p className="empty-description">
            Create jobs for kids to earn extra allowance
          </p>
          <button 
            className="create-btn"
            onClick={handleCreateFirstJob}
          >
            Create First Job
          </button>
        </div>
      )}
      
      {/* TODO: Add job creation modal when showCreateJob is true */}
    </div>
  );
} 